<template>
  <button
    v-show="!functionExecuted"
    :disabled="isButtonDisabled"
    v-bind:class="addLayout()"
    @click="this.handleClick()"
  >
    <i v-bind:class="iconAndColor()">
      <span v-if="this.text !== ''"
        ><b class="flow-margin-left">{{ $t(this.text) }}</b></span
      >
    </i>
  </button>
  <button
    v-show="functionExecuted"
    v-bind:class="addLayout()"
  >
    <i v-bind:class="iconAndColor()">
      <span v-if="this.text !== ''"
        ><b class="flow-margin-left">{{ $t(this.text) }}</b></span
      >
    </i>
  </button>
</template>

<script>

export default {
  name: "QButton",
  props: {
    /**
     * callback function
     */
    callback: {
      type: Function,
      required: true,
    },
    functionExecuted: {
      type: Boolean,
      required: false,
      default: false,
    },
    text: {
      type: String,
      required: false,
      default: "",
    },
    icon: {
      type: String,
      required: false,
      default: "",
    },
    color: {
      type: String,
      required: false,
      default: "",
    },
    disableTimeAfterClicking: {
      type: Number,
      required: false,
      default: 0
    },
    layout: {
      type: String,
      required: false,
      default: "flow-btn w3-btn w3-round w3-border w3-margin-right"
    }
  },
  data() {
    return {
      isButtonDisabled: false
    }
  },
  methods: {
    addLayout() {
      return this.layout;
    },
    iconAndColor() {
      return this.icon + " " + this.color;
    },
    disableAfterClick() {
      this.isButtonDisabled = true;
      setTimeout(() => {
        this.isButtonDisabled = false;
      }, this.disableTimeAfterClicking)
    },
    handleClick() {
      this.callback();
      if (this.disableTimeAfterClicking > 0) this.disableAfterClick();
    }
  },
};
</script>

<style scoped></style>
